import MatterTeamsCard from "@/components/features/settings/defaults/matter-teams/MatterTeamsCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/settings/teams")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersSettingsTeams)) {
    return <GlobalNotAuthorized />;
  }

  return <MatterTeamsCard />;
}
